import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide12OperationsDocs.css';

const operationsItems = [
  'Service planning & scheduling',
  'Global engineer coordination',
  'Rapid response orchestration',
];

const docsItems = [
  'Technical reporting',
  'Certification tracking',
  'Service documentation lifecycle',
  'Regulatory readiness',
];

function Slide12OperationsDocs() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 18 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-ops-docs">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="ops-docs-bg">
        <div className="ops-docs-grid" />
        <div className="ops-docs-glow ops-docs-glow-left" />
        <div className="ops-docs-glow ops-docs-glow-right" />
        <div className="ops-docs-noise" />
      </div>

      <img
        className="ops-docs-ship"
        src="/images/project-sales/ship-network.png"
        alt=""
        aria-hidden="true"
      />

      <div className="ops-docs-content">
        <motion.div className="ops-docs-header" {...fadeUp(0.05)}>
          <h1>Compliance &amp; Documentation Excellence</h1>
        </motion.div>

        <div className="ops-docs-columns">
          <motion.div className="ops-docs-col" {...fadeUp(0.12)}>
            <div className="ops-col-label">OPERATIONS</div>
            <p>
              The operations team includes 15+ experienced staff responsible for local projects, newbuilding, and
              international projects, ensuring seamless coordination from initial request to field execution.
              Operations authorities are reachable 24/7, enabling fast mobilization and controlled response worldwide.
            </p>
            <ul className="ops-list">
              {operationsItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </motion.div>

          <div className="ops-docs-divider" />

          <motion.div className="ops-docs-col" {...fadeUp(0.2)}>
            <div className="ops-col-label">DOCUMENTATION</div>
            <p>
              The Documentation Department is staffed by 10+ team members responsible for annual surveys, VDR surveys,
              radio surveys, and class society audits, ensuring complete and compliant documentation for operational
              continuity.
            </p>
            <ul className="ops-list">
              {docsItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.div className="ops-docs-cards" {...fadeUp(0.28)}>
          <div className="ops-card">
            <div className="ops-card-label">OPERATIONS STAFF</div>
            <div className="ops-card-value">15+</div>
          </div>
          <div className="ops-card">
            <div className="ops-card-label">DOCS SPECIALISTS</div>
            <div className="ops-card-value">10+</div>
          </div>
          <div className="ops-card">
            <div className="ops-card-label">AVAILABILITY</div>
            <div className="ops-card-value">24/7</div>
          </div>
          <div className="ops-card">
            <div className="ops-card-label">TOTAL TEAM</div>
            <div className="ops-card-value">25+</div>
          </div>
        </motion.div>

      </div>
    </div>
  );
}

export default Slide12OperationsDocs;
